import { useContext } from 'react';
import { I18nContext } from './i18nContext';
import { DEFAULT_LANGUAGE, SUPPORTED_LANGUAGES } from './languagePreference';

export default function useTranslation() {
  const context = useContext(I18nContext);
  if (!context) {
    return {
      t: (key) => key,
      language: DEFAULT_LANGUAGE,
      setLanguage: () => {},
      supportedLanguages: SUPPORTED_LANGUAGES,
    };
  }
  return context;
}
